import React, { useState } from 'react';
import Update from '../Update';
import Media from '../Media';

import {
  Card,
  Stack,
  Slide,
  Divider,
  Checkbox,
  Typography,
  CardHeader,
  CardActionArea,
  alpha,
  useTheme,
} from '@mui/material';
import { AvatarPopover, NewSpeedDial } from 'components';
import { useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { hasRequiredRole } from 'helpers';

export default function Model({ model, delay, direction, checked, handleSelect, selectOnClick, refetch, color }) {
  const {
    language: { direction: dir },
  } = useSelector((state) => state.setting);
  const { isAuthenticated, userInfo } = useSelector((state) => state.auth);

  const isRtl = dir === 'rtl';
  const theme = useTheme();

  const [updateOpen, setUpdateOpen] = useState(false);
  const canUpdate = isAuthenticated && hasRequiredRole(['superadmin'], userInfo?.roles);
  const handleRowClick = () => (canUpdate && !selectOnClick ? setUpdateOpen(true) : handleSelect());

  return (
    <>
      <Slide
        in
        unmountOnExit
        direction={direction}
        timeout={{ appear: delay * 100, enter: delay * 120, exit: delay * 140 }}
      >
        <Card
          sx={{
            position: 'relative',
            // bgcolor: checked && 'action.disabledBackground',
            bgcolor: checked ? 'primary.light' : color ? 'action.disabledOpacity' : 'action.focus',
          }}
        >
          <Stack
            left={8}
            zIndex={1}
            columnGap={0.5}
            height="100%"
            alignItems="center"
            position="absolute"
            justifyContent="flex-start"
            direction={isRtl ? 'row' : 'row-reverse'}
          >
            <Checkbox size="small" checked={checked} onChange={handleSelect} />
            <Media
              id={model.id}
              model="ShiftType"
              collection="avatar"
              title={model.title}
              subheader={model.producer?.title || 'برند'}
            >
              <AvatarPopover media={model?.media[0]?.full_url} />
            </Media>
          </Stack>
          <Stack
            right={8}
            zIndex={1}
            columnGap={0.5}
            height="100%"
            direction="row"
            alignItems="center"
            position="absolute"
            justifyContent="flex-end"
          >
            <NewSpeedDial>
              {isAuthenticated && hasRequiredRole(['superadmin'], userInfo?.roles) && (
                <>
                  <Update ids={model.id} title={<FormattedMessage id="update" />} refetch={refetch} />
                  <Media id={model.id} model="ShiftType" collection="banner" />
                </>
              )}
            </NewSpeedDial>
          </Stack>
          <CardActionArea onClick={handleRowClick}>
            <CardHeader
              sx={{ px: 0.5, pl: 13 }}
              title={
                <Typography textAlign={isRtl ? 'start' : 'end'} fontSize={14} variant="subtitle1">
                  {model.title}
                </Typography>
              }
              subheader={
                <Typography fontSize={12} variant="subtitle2">
                  {model.producer?.title}
                </Typography>
              }
            />
          </CardActionArea>
        </Card>
      </Slide>
      {updateOpen && (
        <Update
          open
          ids={model.id}
          refetch={refetch}
          title={<FormattedMessage id="update" />}
          onClose={() => setUpdateOpen(false)}
        />
      )}
      <Divider variant="middle" />
    </>
  );
}
